module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"carbonTable.exportText.btnText":"Export CSV"}}')
  delete Component.options._Ctor
}
